import { z } from "@/zod";
import { readStore } from "./store";
import { readProjectPeriod } from "./projectPeriod";

const projectStorePeriod = z.object({
  ref_number: z.coerce.number().nonnegative(),
  name: z.string().min(1),
  client_store_number: z.string().min(1),
  ...readStore.unwrap().omit({
    name: true,
    ref_number: true,
    client_store_number: true,
    shopping_center: true,
    notes: true,
    province: true,
    province_id: true,
    latitude: true,
    longitude: true,
  }).shape,
  periods: z.array(readProjectPeriod),
});

export const readProjectStorePeriod = projectStorePeriod.readonly();

export const displayProjectStorePeriod = projectStorePeriod
  .extend({
    actions: z.array(z.string()),
  })
  .omit({ periods: true })
  .readonly();

export const storeInPeriod = z.object({
  period_id: z.string().length(26),
  add: z.array(z.string().length(26)),
  delete: z.array(z.string().length(26)),
});

export const clientStoreNumber = z.object({
  store_id: z.string().length(26),
  store_number: z.string().nullable().optional(),
});

export const writeProjectStorePeriod = z.object({
  stores_in_periods: z.array(storeInPeriod),
  client_store_numbers: z.array(clientStoreNumber),
});
